import { createPortal } from "react-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

export function Overlay({ onClose, testId, children }) {
  return createPortal(
    <div
      className="fixed inset-0 z-[100] bg-black/80 flex items-start justify-center p-4 sm:p-10 overflow-y-auto"
      onClick={onClose}
      data-testid={testId}
    >
      {children}
    </div>,
    document.body,
  );
}

export const inputCls =
  "w-full bg-bdu-surface2 border border-bdu-gold/25 focus:border-bdu-gold outline-none text-bdu-cream px-3 py-2 text-sm disabled:opacity-60";

export function Field({ label, children, className = "" }) {
  return (
    <label className={`block ${className}`}>
      <div className="text-[10px] tracking-[0.22em] uppercase text-bdu-cream/60 mb-1.5">{label}</div>
      {children}
    </label>
  );
}

export function formatIso(s) {
  if (!s) return "";
  try {
    const d = new Date(s);
    return d.toLocaleString(undefined, {
      weekday: "short", month: "short", day: "numeric",
      hour: "numeric", minute: "2-digit",
    });
  } catch { return s; }
}

export const FORMAT_LABELS = {
  virtual: "Virtual (Jitsi)",
  in_person: "In person",
  phone: "Phone conference",
  hybrid: "Hybrid",
};

// Authenticated PDF download (axios blob → browser save).
export async function downloadPdf(path, fallbackName) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const cd = r.headers["content-disposition"] || "";
    const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || fallbackName;
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
    return true;
  } catch (e) {
    let detail = e.response?.data;
    if (detail instanceof Blob) {
      try { detail = JSON.parse(await detail.text()).detail; } catch { detail = null; }
    }
    toast.error(formatApiError(detail) || "Download failed");
    return false;
  }
}
